/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Catalogue_View_MineInputs */



/**
* | output |
* | --- |
* | "My agents" |
*
* @param {Agent_Catalogue_View_MineInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_catalogue_view_mine = /** @type {((inputs?: Agent_Catalogue_View_MineInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Catalogue_View_MineInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Meine Agenten")
	return /** @type {LocalizedString} */ ("My agents")
});